import { useState, useEffect } from 'react';

interface SlotSize {
  S: number;
  GAP: number;
  charMaxW: number;
}

function compute(): SlotSize {
  const w = window.innerWidth;
  if (w >= 2555) return { S: 112, GAP: 40, charMaxW: 430 };
  if (w >= 1921) return { S: 90,  GAP: 32, charMaxW: 340 };
  if (w >= 1601) return { S: 84,  GAP: 26, charMaxW: 320 };
  if (w >= 1520) return { S: 78,  GAP: 22, charMaxW: 290 };
  if (w >= 1440) return { S: 74,  GAP: 18, charMaxW: 270 };
  if (w >= 1368) return { S: 68,  GAP: 14, charMaxW: 240 };
  return                { S: 62,  GAP: 10, charMaxW: 200 };
}

export function useEquipmentSlotSize(): SlotSize {
  const [size, setSize] = useState(compute);
  useEffect(() => {
    const handler = () => setSize(compute());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return size;
}
